import { Entry, isEntry } from '../entries';
import { Block } from './blocks';

export const handleMediaReleaseStatement = (blocks: Block[], entry?: Entry): Block[] => {
  if (!isEntry(entry, 'article') || !entry.mediaRelease) return blocks;

  const hasMediaReleaseBlock = blocks.some(
    (block) => block.__typename === 'blocks_mediaReleaseStatement_BlockType'
  );

  if (hasMediaReleaseBlock) return blocks;

  const indexOfLastTextBlock = blocks.reduce((acc, block, index) => {
    return block.__typename === 'blocks_richText_BlockType' ? index : acc;
  }, -1);

  const mediaReleaseBlock: Block<'blocks_mediaReleaseStatement_BlockType'> = {
    __typename: 'blocks_mediaReleaseStatement_BlockType',
    id: 'media-release-statement',
  };

  // Insert media release statement block after the last text block, or at the end of the blocks array
  if (indexOfLastTextBlock === -1) {
    blocks.push(mediaReleaseBlock);
  } else {
    blocks.splice(indexOfLastTextBlock + 1, 0, mediaReleaseBlock);
  }

  return blocks;
};
